/** @typedef {import('@datahooks/types/tagging.types').OrganisationTagValue} OrganisationTagValue */

import React from 'react';

import { TestableChip } from '@components/general/TestableComponents';

import PropTypes from "prop-types";
import { OrganisationTagValuePropType } from '@datahooks/types/tagging.types';

/**
 * Component to display tag values as chips with remove option
 * 
 * @param {Object} props
 * @param {OrganisationTagValue[]} props.tagValues List of tag values to display
 * @param {Function} props.onRemove Callback when a tag value is removed
 * 
 * @returns JSX.Element
 */
const ProjectTagValues = ({ tagValues, onRemove }) => {

    /**
     * Handler for removing a tag value
     * 
    * @type {Function}
    * @param {OrganisationTagValue} tagValue The tag value to remove
    * @returns {void} 
    */
    const removeTag = (tagValue) => {
        onRemove?.(tagValue);
    }

    return (
        <div className='flex flex-wrap gap-2'>
            {tagValues && tagValues.length > 0 ? (
                tagValues.map((value) => (
                    <TestableChip className='bg-blue-500' key={value.tag_value_id} value={value.title} onClose={() => removeTag(value)} />
                ))
            ) : (
                <span className='text-gray-500 text-sm'>No values</span>
            )}
        </div>
    );
}

export default ProjectTagValues;

ProjectTagValues.propTypes = {
    tagValues: PropTypes.arrayOf(OrganisationTagValuePropType).isRequired,
    onRemove: PropTypes.func,
};